module.exports = __webpack_public_path__ + "53b04078e41014f8b5bb7f2053da6648.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_38.jpg
// module id = 1676
// module chunks = 5